import script from "./HeaderWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWrapper.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWrapper.vue?vue&type=style&index=0&id=641f71a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641f71a8"]])

export default __exports__